import React from 'react'
import MobileEmptyStateCard from '../../../components/MobileEmptyStateCard'
import resolveIcon from '../../../components/icon/resolveIcon'
import { getEffectivenessReportTab } from '../../../components/constants/effectivenessReportTabs'

const EMPTY_TITLE = 'No hay actividades'
const EMPTY_DESCRIPTION =
  'Cuando existan registros en el rango seleccionado, aparecerán aquí con su detalle.'

export default function EffectivenessReportEmptyState({ tabValue }) {
  const tab = getEffectivenessReportTab(tabValue)
  const icon = resolveIcon({
    icon: tab?.icon,
    size: tab?.iconSize ?? 22,
    filled: Boolean(tab?.filled)
  })

  return <MobileEmptyStateCard icon={icon} title={EMPTY_TITLE} description={EMPTY_DESCRIPTION} />
}
